import {InputWidget, InputWidgetOptionType} from './widget.input';

export class TextWidget extends InputWidget {
	type: string = 'text';
	inputType!: string;

	constructor(options: {
		value?: string | null;
		name?: string;
		label?: string;
		required?: boolean;
		options?: InputWidgetOptionType[];
	} = {}) {
		super({...options, ...{inputType: 'text'}});
	}
}
